<template>
<div>
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_buffet_manage">
                <img src="@/assets/fried-chicken.png">
            </div>
            <h2 class="title_buffet_manage">จัดการบุฟเฟ่ต์</h2>
        </div>
        <v-btn color="#28ab28" class="white--text like_back_title_buffet_manage" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <MenuManageFood />
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มบุฟเฟ่ต์เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขบุฟเฟ่ต์เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="text-right mb-2">
            <v-btn color="#038cc1" class="white--text" @click="openAddBuffet()" width="20%" height="65">
                เพิ่มรายการ
            </v-btn>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.number}}</td>
                        <td>{{dataDetail.item.name_ragne}}</td>
                        <td>{{dataDetail.item.status_timer}}</td>
                        <td>{{dataDetail.item.buffet_time}}</td>
                        <td>
                            <span>
                                <v-switch color="success" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                            </span>
                        </td>
                        <td>
                            <span class="edit_data_buffet_manage" @click="detailEditBuffet(dataDetail.item.id,0)">
                                <v-icon dark right color="grey">mdi-magnify</v-icon>
                            </span>
                            <span class="edit_data_buffet_manage" @click="detailEditBuffet(dataDetail.item.id,1)">
                                <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
    <v-dialog v-model="open_detail_buffet" persistent max-width="1000px">
        <div v-if="loading_detail_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_detail_page === false">
            <v-card-title class="justify-space-between">
                <div>
                    รายละเอียดบุฟเฟต์
                </div>
                <div class="cursor_buffet_manage" @click="open_detail_buffet = false">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="mb-3">
                    <h2 class="mr-1">
                        ชื่อบุฟเฟต์ {{ name_ragne }}
                    </h2>
                </div>
                <div class="mb-3" v-if="status_timer == 1">
                    <h2 class="mb-3">นับเวลาบุฟเฟต์ {{ timer_text }}</h2>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-center border_header_buffet_manage"  width="50%">
                                    รายการปรับเกินเวลา
                                </th>
                                <th class="text-center border_header_buffet_manage"  width="50%">
                                    ค่าปรับ
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center border_header_buffet_manage">
                                    เกินเวลา 10-30 นาที
                                </td>
                                <td class="text-center border_header_buffet_manage">
                                    {{ indemnity_one }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center border_header_buffet_manage">
                                    เกินเวลา 30 นาที ขึ้นไป
                                </td>
                                <td class="text-center border_header_buffet_manage">
                                    {{ indemnity_two }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <h2 class="mb-3" v-if="status_timer == 0">ไม่นับเวลาบุฟเฟต์</h2>
                <h2 class="mb-3">
                    รายการ
                </h2>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th class="text-center border_header_buffet_manage">
                                ลำดับ
                            </th>
                            <th class="text-center border_header_buffet_manage">
                                ชื่อ (ไทย)
                            </th>
                            <th class="text-center border_header_buffet_manage">
                                ชื่อ (อังกฤษ)
                            </th>

                            <th class="text-center border_header_buffet_manage">
                                ราคา
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(setting_detail,index) in setting_list" :key="index">
                            <td class="text-center border_header_buffet_manage">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center border_header_buffet_manage">
                                {{ setting_detail.name }}
                            </td>
                            <td class="text-center border_header_buffet_manage">
                                {{ setting_detail.name_eng }}
                            </td>
                            <td class="text-center border_header_buffet_manage">
                                {{ setting_detail.price }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="open_add_or_edit_buffet" persistent max-width="1000px">
        <div v-if="loading_detail_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_detail_page === false">
            <v-form ref="form" @submit.prevent="addOrEditBuffet()">
                <v-card-title class="justify-space-between">
                    <div>
                        {{ edit_id ? 'แก้ไข' : 'เพิ่ม'}}รายการ บุฟเฟต์
                    </div>
                    <div class="cursor_buffet_manage" @click="open_add_or_edit_buffet = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <div>
                        <v-text-field label="ชื่อบุฟเฟต์" :rules="[v => !!v || 'กรุณากรอกชื่อบุฟเฟต์']" v-model="name_ragne" required outlined></v-text-field>
                    </div>

                    <div class="d-flex font_setting_buffet_manage">
                        <v-checkbox color="primary" class="ma-0 pa-0" v-model="status_timer"></v-checkbox>
                        <div>นับเวลาบุฟเฟต์</div>
                    </div>

                    <div class="mb-3" v-if="status_timer == 1">
                        <v-row>
                            <v-col cols="4">
                                <div>
                                    <v-select label="ชั่วโมง" :items="hours_list" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกชั่วโมง']" v-model="timer_hours" required outlined></v-select>
                                </div>
                            </v-col>
                            <v-col cols="4">
                                <div>
                                    <v-select label="นาที" :items="seconds_list" color="primary" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกนาที']" v-model="timer_seconds" required outlined></v-select>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="font_setting_buffet_manage mb-2">รายการปรับเกินเวลา</div>
                        <v-row>
                            <v-col cols="4" class="d-flex justify-center align-center">
                                <div class="font_setting_buffet_manage color_text_detail_time">เกินเวลา 10-30 นาที</div>
                            </v-col>   
                            <v-col cols="4">
                                <div>
                                    <v-text-field label="ค่าปรับ" type="tel" onpaste="return false" @keypress="isNumberOnly($event)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกค่าปรับ']" v-model="indemnity_one" required outlined></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4 d-flex justify-center align-center">
                                <div class="font_setting_buffet_manage color_text_detail_time">เกินเวลา 30 นาที ขึ้นไป</div>
                            </v-col>
                            <v-col cols="4">
                                <div>
                                    <v-text-field label="ค่าปรับ" type="tel" onpaste="return false" @keypress="isNumberOnly($event)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกค่าปรับ']" v-model="indemnity_two" required outlined></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="d-flex align-center mb-3">
                        <div class="mr-1 font_setting_buffet_manage">ตั้งค่ารายการ</div>
                        <div>
                             <v-btn color="#038cc1" class="white--text" height="50" type="button" @click="addSetting()">
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <v-row class="align-center" v-for="(setting_detail,index) in setting_list" :key="index">
                        <v-col cols="1">
                            <div class="text-center font_setting_buffet_manage">{{ index + 1 }}</div>
                        </v-col>
                        <v-col cols="3">
                            <div>
                                <v-text-field label="ชื่อไทย" :rules="[v => !!v || 'กรุณากรอกชื่อไทย']" hide-details="auto" v-model="setting_detail.name" required outlined></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div>
                                <v-text-field label="ชื่ออังกฤษ" :rules="[v => !!v || 'กรุณากรอกชื่ออังกฤษ']" hide-details="auto" v-model="setting_detail.name_eng" required outlined></v-text-field>
                            </div>
                        </v-col>
                         <v-col cols="4">
                            <div>
                                <v-text-field label="ราคา" type="number" @keypress="isNumber($event)" onpaste="return false" :rules="[v => !!v || 'กรุณากรอกราคา']" hide-details="auto" v-model="setting_detail.price" required outlined></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="1">
                            <div class="text-center cursor_buffet_manage" @click="removeSetting(setting_detail.no)" v-if="setting_list.length != 1">
                                <v-icon size="40">mdi-delete</v-icon>
                            </div>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" width="20%" type="submit">
                        บันทึก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import MenuManageFood from '@/components/menuadmin/MenuManageFood.vue'
export default {
    name: 'buffetManage',
        components: {
        MenuManageFood,
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_detail_page: true,
            alert_show: false,
            alert_show_add: false,
            alert_show_edit: false,
            open_detail_buffet: false,
            open_add_or_edit_buffet: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },

                {
                    text: 'ชื่อรายการ',
                    value: 'name_ragne'
                },
                {
                    text: 'นับเวลา',
                    value: 'status_timer'
                },
                {
                    text: 'เวลาบุฟเฟต์',
                    value: 'buffet_time'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
            hours_list:[
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
            ],
            seconds_list:[
                '00',
                '01',
                '02',
                '03',
                '04',
                '05',
                '06',
                '07',
                '08',
                '09',
                '10',
                '11',
                '12',
                '13',
                '14',
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21',
                '22',
                '23',
                '24',
                '25',
                '26',
                '27',
                '28',
                '29',
                '30',
                '31',
                '32',
                '33',
                '34',
                '35',
                '36',
                '37',
                '38',
                '39',
                '40',
                '41',
                '42',
                '43',
                '44',
                '45',
                '46',
                '47',
                '48',
                '49',
                '50',
                '51',
                '52',
                '53',
                '54',
                '55',
                '56',
                '57',
                '58',
                '59',
                '60',
            ],
            edit_id: null,
            name_ragne: null,
            status_timer: false,
            timer_hours: null,
            timer_seconds: null,
            timer_text: null,
            indemnity_one: null,
            indemnity_two: null,
            no:0,
            setting_list:[],
        }
    },
    methods: {
        async isNumber(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async isNumberOnly(evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        async openAddBuffet(){
            this.loading_detail_page = true
            this.open_add_or_edit_buffet = true
            this.edit_id = null
            this.name_ragne = null
            this.no = 0
            this.no += 1
            this.setting_list = [
                {
                    no:this.no,
                    id:null,
                    name:null,
                    name_eng:null,
                    price:null,
                }
            ] 
            this.loading_detail_page = false
        },
        async addSetting(){
            this.no += 1
            this.setting_list.push(
                {
                    no:this.no,
                    id:null,
                    name:null,
                    name_eng:null,
                    price:null,
                }
            )
        },
        async removeSetting(no){
            this.setting_list = this.setting_list.filter((detail) => { return detail.no !== no })
        },
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        for (let index = 0; index < response.data.list.length; index++) {
                            response.data.list[index].number = index + 1
                        }
                        this.data = response.data.list
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeStatus(id) {
            HTTP.post('/buffet/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }

                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async addOrEditBuffet() {
            if (this.$refs.form.validate()) {
                this.loading_detail_page = true
                if (this.edit_id === null) {
                    let timer = this.timer_hours + ':' + this.timer_seconds
                    let name = this.setting_list.map((detail) => { return detail.name })
                    let name_eng = this.setting_list.map((detail) => { return detail.name_eng })
                    let price = this.setting_list.map((detail) => { return detail.price })
                    HTTP.post('/buffet/create', {
                            name_ragne: this.name_ragne,
                            status_timer: this.status_timer === true || this.status_timer == 1 ? 1 : 0,
                            timer: timer,
                            indemnity_one: this.indemnity_one,
                            indemnity_two: this.indemnity_two,
                            name: name,
                            name_eng: name_eng,
                            price: price,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.loading_page = true
                                this.open_add_or_edit_buffet = false
                                this.name_ragne = null
                                this.setting_list = []
                                this.buffetList()
                                this.alert_show_add = true
                                setTimeout(() => this.alert_show_add = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })

                }else{
                    let manage_buffet_id = []
                    let timer = this.timer_hours + ':' + this.timer_seconds
                    let name = []
                    let name_eng = []
                    let price = []
                    this.setting_list.forEach((detail) => {
                        manage_buffet_id.push(detail.id)
                        name.push(detail.name)
                        name_eng.push(detail.name_eng)
                        price.push(detail.price)
                    })
                    HTTP.post('/buffet/update', {
                            id: this.edit_id,
                            name_ragne: this.name_ragne,
                            status_timer: this.status_timer === true || this.status_timer == 1 ? 1 : 0,
                            timer: timer,
                            indemnity_one: this.indemnity_one,
                            indemnity_two: this.indemnity_two,
                            manage_buffet_id: manage_buffet_id,
                            name: name,
                            name_eng: name_eng,
                            price: price,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.loading_page = true
                                this.open_add_or_edit_buffet = false
                                this.edit_id = null
                                this.name_ragne = null
                                this.setting_list = []
                                this.buffetList()
                                this.alert_show_edit = true
                                setTimeout(() => this.alert_show_edit = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                }
            }
        },
        async detailEditBuffet(id,type) {
            if (type === 0) {
                this.open_detail_buffet = true
            }
            if (type === 1) {
                this.open_add_or_edit_buffet = true
            }
            this.loading_detail_page = true
            this.edit_id = null
            this.name_ragne = null
            this.status_timer = null
            this.timer_hours = null
            this.timer_seconds = null
            this.timer_text = null
            this.indemnity_one = null
            this.indemnity_two = null
            this.no = 0
            this.setting_list = []
            HTTP.get('/buffet/get-old/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = response.data.buffet_detail.id
                        this.name_ragne = response.data.buffet_detail.name_ragne
                        this.status_timer = response.data.buffet_detail.status_timer
                        if (this.status_timer != 0) {
                            let timer_arr = response.data.buffet_detail.timer.split(':')
                            this.timer_hours = timer_arr[0]
                            this.timer_seconds = timer_arr[1]
                            this.timer_text = response.data.buffet_detail.buffet_time
                            this.indemnity_one = response.data.buffet_detail.indemnity_one
                            this.indemnity_two = response.data.buffet_detail.indemnity_two
                        }

                        response.data.buffet_detail.list.forEach((detail) => {
                            this.no += 1
                            this.setting_list.push({
                                no:this.no,
                                id:detail.id,
                                name:detail.name,
                                name_eng:detail.name_eng,
                                price:detail.price,
                            })
                        })
                        this.loading_detail_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>
<style scoped>
    .cursor_buffet_manage{
        cursor: pointer;
    }
    .font_setting_buffet_manage{
        font-size: 20px;
    }
    .border_header_buffet_manage {
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .color_text_detail_time{
        color: #565656;
    }
</style>